/// <amd-module name="Wit/Common/BulkUpdateUtils/BulkUpdateInterfaces" />

export namespace BulkUpdateConstants {
    /**
     * Indicates that the list of work item changes is applicable to all work item types
     */
    export const AllTypes = "AllTypes";
}

/**
 * Field name and the value mapping to update work item(s)
 */
export interface IWorkItemFieldChange {
    /**
     * identifier for the field (string or enum)
     */
    fieldName: string;

    /**
     * value for the update
     */
    value: any;
}
